import { render, staticRenderFns } from "./applyForOther.vue?vue&type=template&id=13c4ea41&scoped=true&"
import script from "./applyForOther.vue?vue&type=script&lang=js&"
export * from "./applyForOther.vue?vue&type=script&lang=js&"
import style0 from "./applyForOther.vue?vue&type=style&index=0&id=13c4ea41&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4ea41",
  null
  
)

export default component.exports